module.exports = __webpack_public_path__ + "aea1d98fd432d6703ed68ade438e9cf5.svg";